import PropTypes from 'prop-types';
import React from 'react';
import { Box, Avatar, Tooltip, Typography } from '@mui/material';
import { Iconify } from 'src/components';
import { useSelector } from '../../../../redux/store';
import { getLastContactChannelMeta } from '../../../../utils/lastContact';
import { showLastContactedDate } from '../../../../utils/leadTableUtils';
import {
    dateTimeTypoStyle,
    tableCellInnerBoxStyle
} from '../../../../styles/NewLeadTableRowStyle';

const getInitials = (name) => {
    if (!name) return '';
    const parts = String(name).trim().split(/\s+/);
    return (parts[0]?.[0] || '').concat(parts[1]?.[0] || '').toUpperCase();
};

const LastContactedField = ({ rowData }) => {
    const { dateLastContactFormat } = useSelector((state) => state.lead);
    const hasNoContact = rowData?.last_time_contacted === 'No contact';
    const channel = getLastContactChannelMeta(rowData?.last_time_contacted_channel);

    if (hasNoContact) {
        return (
            <Box sx={{ ...tableCellInnerBoxStyle, justifyContent: 'center' }}>
                <Iconify
                    icon='mdi:phone-off-outline'
                    sx={{ color: 'rgba(145, 158, 171, 0.5)', width: 16, height: 16 }}
                />
            </Box>
        );
    }

    return (
        <Box sx={{ ...tableCellInnerBoxStyle, justifyContent: 'flex-start' }}>
            <Box sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                <Avatar
                    sx={{ width: 28, height: 28, mr: 1, bgcolor: '#919EAB3D', fontSize: '0.75rem' }}
                    src={rowData?.last_time_created_by_avatar || undefined}
                >
                    {getInitials(rowData?.last_time_updated_by)}
                </Avatar>
                {channel && (
                    <Tooltip title={`${channel.label} last contact`}>
                        <Iconify
                            icon={channel.icon}
                            aria-label={`${channel.label} last contact`}
                            sx={{ width: 16, height: 16, mr: 0.75, color: channel.color, flexShrink: 0 }}
                        />
                    </Tooltip>
                )}
                <Typography variant='05 Others/Label' dangerouslySetInnerHTML={{ __html: showLastContactedDate(dateLastContactFormat, rowData) }} sx={dateTimeTypoStyle} />
            </Box>
        </Box>
    );
};

LastContactedField.propTypes = {
    rowData: PropTypes.object,
};

export default LastContactedField;
